import { render } from "./ExplanationComponent.vue?vue&type=template&id=e7e1a292&scoped=true"
import script from "./ExplanationComponent.vue?vue&type=script&lang=js"
export * from "./ExplanationComponent.vue?vue&type=script&lang=js"

import "./ExplanationComponent.vue?vue&type=style&index=0&id=e7e1a292&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e1a292"]])

export default __exports__